import { useContext } from 'react';
import { CardContext } from '../hoc/CardProvider';

export function useCard() {
	const context = useContext(CardContext);
	if (context === null) {
		throw new Error('useCard must be used within a CardProvider');
	}
	return context;
}
